import { Edit3 } from "lucide-react";

interface BulkEditInfoBannerProps {
  fieldLabel: string;
  itemCount: number;
}

export function BulkEditInfoBanner({ fieldLabel, itemCount }: BulkEditInfoBannerProps) {
  return (
    <div className="flex items-center gap-3 p-4 bg-blue-50 dark:bg-blue-950/40 rounded-lg">
      <Edit3 className="h-5 w-5 text-blue-600" />
      <div>
        <h3 className="font-medium text-blue-900">
          Edit {fieldLabel} for {itemCount} item{itemCount === 1 ? "" : "s"}
        </h3>
        <p className="text-sm text-blue-700">
          This will update the {fieldLabel.toLowerCase()} field for all selected items
        </p>
      </div>
    </div>
  );
}
